import { WasteCategory, WasteCategoryArticle } from '../interfaces'


export const toTableRowItems = (data: any[]): WasteCategoryArticle[] => {
  return data.map((row: any) => ({
    id: row.articleId ?? '',
    regularizationCode: row.regularizationCode ?? '',
    regularizationDescription: row.regularizationDescription ?? '',
    dateOfRegularization: row.dateOfRegularization ?? '',
    articleId: row.articleId ?? '',
    articleName: row.articleName ?? '',
    salesUnit: row.salesUnit ?? '',
    pcb: row.pcb ?? 0,
    totalNumberOfPiecesPerArticle: row.totalNumberOfPiecesPerArticle ?? 0,
    individualGrossWeightPerArticle: row.totalNumberOfPiecesPerArticle ?? 0,
    totalGrossWeightPerLine: row.totalGrossWeightPerLine ?? 0,
    purchasePricePerArticle: row.purchasePricePerArticle ?? 0,
    pmpPerArticle: row.pmpPerArticle ?? 0,
    salesPricePerLineWithoutTax: row.salesPricePerLineWithoutTax ?? 0,
    salesPricePerLineWithTax: row.salesPricePerLineWithTax ?? 0,
  }))
}

export const toWasteCategory = (data: any): WasteCategory => {
  return {
    categoryName: data.categoryName ?? '',
    totalPriceHT: data.totalPriceHT ?? 0,
    totalPriceTTI: data.totalPriceTTI ?? 0,
    totalAveragePrice: data.totalAveragePrice ?? 0,
    totalPurchasePrice: data.totalPurchasePrice ?? 0,
    articles: toTableRowItems(data.articles),
  }
}